import React, { useState, useEffect } from "react";
import {
  getAllPartySearch,
  getAllGeneralLedger,
  getAllItemsSearch,
} from "../../api/endpoints/search";
import {
  getVoucher,
  saveData,
  getData,
  updateTankLorry,
  deleteSingleTankLorry,
  deleteTankLorry,
} from "../../api/endpoints/tankLorry";
import { AiFillSave } from "react-icons/ai";
import { AiFillDelete } from "react-icons/ai";
import { AiFillEdit } from "react-icons/ai";
import { AiFillFileAdd } from "react-icons/ai";
import { BiExit } from "react-icons/bi";
import SideBar from "../sidebar/sideBar";
// import "./receipts.css";
import { authSelector } from "../../store/selectors/index";
import { Modal, message } from "antd";
import { Button, Dropdown, Select, Menu } from "antd";
import { useSelector } from "react-redux";
import Popup from "../modals/Popup";
import { getTankById } from "../../api/endpoints/tank";

const { Option } = Select;

const TankLorry = () => {
  const { user, access_token } = useSelector(authSelector);

  const [voucher, setVoucher] = useState();
  const [type, setType] = useState("ADD");
  const [dateEntered, setDateEntered] = useState("");
  const [shift, setShift] = useState("");
  const [itemsQueue, setItemsQueue] = useState([]);
  const [editedItem, setEditedItem] = useState(null);
  const [fieldsShow, setFieldsShow] = useState(false);
  const [total, setTotal] = useState();

  console.log(type, "type");

  // -------------------------- STATE ----------

  const [state, setState] = useState({
    id: "",
    items: [],
    parties: [],
    ledgerCodes: [],
    tanks: [],
    tank: "",
    itemCode: "",
    itemName: "",
    partyId: "", //ac no.
    partyName: "", // supplier name
    glCode: "",
    glDescription: "",
    purchaseRate: "",
    quantity: "",
    remrks: "",
    lorryNo: "",
    amount: "",
    retrn: "",
    saleRate: "",
    voucher: ""
  });

  const clearState = () => {
    setState({
      parties: state.parties,
      ledgerCodes: state.ledgerCodes,
      items: state.items,
      tanks: state.tanks,
      tank: "",
      itemCode: "",
      itemName: "",
      id: "",
      partyId: "", //ac no.
      partyName: "", // supplier name
      glCode: "",
      glDescription: "",
      purchaseRate: "",
      quantity: "",
      remrks: "",
      lorryNo: "",
      amount: "",
      retrn: "",
      saleRate: "",
      voucher: ""
    });
  };

  const clearStates = () => {
    clearState();
    setEditedItem(null);
    setFieldsShow(false);
    setItemsQueue([]);
    setShift("");
    setDateEntered("");
    setVoucher("");
    setTotal(0);
    setType("ADD");
  };

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };

  // ------------------- ADD VOUCHER ---------------

  const addVoucher = async () => {
    if (!dateEntered) return message.error("Please type date !");
    const payload = {
      enteredOn: dateEntered,
    };
    const result = await getVoucher(payload, access_token);
    console.log(result, "result");
    if (result.success) {
      // setVoucher(result.data);
      setType("SAVE");
      setFieldsShow(true);
    } else {
      message.error(result.message);
    }
  };
  // ------------------ SAVE DATA -----------------
  console.log(state, "state-=-=-=", type);

  const save = async () => {
    if (!shift) return message.error("Please type shift!");
    if (itemsQueue.length === 0) return message.error("Add minimun 1 Entry");

    const payload = itemsQueue.reduce((acc, curr) => {
      return [
        ...acc,
        {
          enteredOn: dateEntered,
          shift: Number(shift),
          // generalLedgerCode: curr.glCode,
          // partyId: Number(curr.partyId),
          itemCode: curr.itemCode,
          quantity: Number(curr.quantity),
          purchaseRate: Number(curr.purchaseRate),
          // saleRate: Number(curr.saleRate),
          amount: Number(curr.amount),
          retrn: Number(curr.retrn),
          // tankNumber: curr.tank,
          // remrks: curr.remrks,
          lorryNo: curr.lorryNo,
          VNO: Number(curr.voucher),
          // grpId: Number(user.grpId),
          siteId: Number(user.siteId),
          // companyCode: Number(user.companyCode),
        },
      ];
    }, []);

    console.log(payload, "payloadd");
    const result = await saveData(payload, access_token);
    if (result.success) {
      clearStates();
      message.success(result.message || "Successfully entered!");
    }
  };

  // ---------------- ALL ITEMS ----------------

  const getAllData = async () => {
    const _items = await getAllItemsSearch(access_token);
    const _parties = await getAllPartySearch(access_token);
    const _ledgerCodes = await getAllGeneralLedger(access_token);
    setState({
      ...state,
      items: _items,
      parties: _parties,
      ledgerCodes: _ledgerCodes,
    });
  };
  useEffect(() => {
    getAllData();
    if (itemsQueue.length === 0) return;

    let creditSum = itemsQueue.reduce(
      (arr, curr) => arr + Number(curr?.amount || 0),
      0
    );
    setTotal(Number(creditSum));

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsQueue]);

  console.log(total, "totttt");

  const getItemsaleRate = async () => {
    const result = await getTankById(state.itemCode, access_token);
    if (result.success) {
      console.log(result, "tankRESLT");
      setState({
        ...state,
        // tanks: result.data,
        // tank: result.data[0].tankNumber,
        // saleRate: result.data[0].item.saleRate,
        purchaseRate: result.data[0].item.purchaseRate,
      });
    }
  };

  useEffect(() => {
    if (state.itemCode) {
      getItemsaleRate();
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.itemCode]);

  // ---------------------- ADD ITEM TO QUEUE --------------

  const addItem = () => {
    if (
      !state.itemCode ||
      // !state.partyId ||
      // !state.glCode ||
      !state.quantity ||
      !(state.amount || state.retrn)
      // !state.saleRate ||
      // !state.purchaseRate
    ) {
      return message.error(
        `Please type ${
          !state.itemCode
            ? "item"
            : // : !state.glCode
            // ? "GL code"
            // : !state.partyId
            // ? "Party Id"
            !state.quantity
            ? "quantity"
            : !(state.amount || state.retrn)
            ? "Please type amount or return"
            : "" // : !state.saleRate
          // ? "Sale Rate"
          // !state.purchaseRate
          // ? "Purchase Rate"
          // : ""
        }`
      );
    } else {
      setItemsQueue([...itemsQueue, state]);
      clearState();
    }
  };

  console.log(itemsQueue, "items queue-=-=--=");
  // -------- EDIT ITEM

  const editItem = async () => {
    if (state.id) {
      await updateSingleApi();
    } else {
      itemsQueue[editedItem] = state;
      setItemsQueue([...itemsQueue]);
      setEditedItem(null);
      clearState();
    }
  };

  // -------- EDIT ITEM

  const deleteItem = (index) => {
    // const prevObject = itemsQueue[i]
    itemsQueue.splice(index, 1);
    setItemsQueue([...itemsQueue]);
    setEditedItem(null);
    console.log("deleteItem");
    clearState();
  };

  // ---------------------- EDIT API ------------------

  const [editPopup, setEditpopup] = useState(false);
  const edit = () => {
    setEditpopup(true);
  };

  const editHandler = async () => {
    if (!voucher) return message.error("Please type voucher number!");
    const results = await getData(voucher, access_token);
    if (results.success) {
      console.log(results, "ressaaaaa");
      const payload = results.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            // partyId: Number(curr.partyId ),
            // glDescription: curr.chartOfAccount.description,
            // tank: curr.tankNumber,
            // glCode: Number(curr.generalLedgerCode),
            amount: Number(curr.amount),
            retrn: Number(curr.retrn),
            quantity: Number(curr.quantity),
            purchaseRate: Number(curr.purchaseRate),
            // saleRate: Number(curr.saleRate),
            itemCode: curr.itemCode,
            // itemName: curr.item.itemName,
            items: state.items,
            // remrks: curr.remrks,
            lorryNo: curr.lorryNo,
            VNO: curr.voucher
            // ledgerCodes: state.ledgerCodes,
            // parties: state.parties,
            // tanks: state.tanks,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setEditpopup(false);
      setType("EDIT");
    } else {
      message.error(results.message);
    }
  };

  // ---------------------- EDIT SINGLE API ------------------

  const updateSingleApi = async () => {
    if (
      !state.itemCode ||
      // !state.partyId ||
      // !state.glCode ||
      !state.quantity ||
      !state.amount ||
      state.retrn
      // !state.saleRate ||
      // !state.purchaseRate
    ) {
      return message.error(
        `Please type ${
          !state.itemCode
            ? "item"
            : // : !state.glCode
            // ? "GL code"
            // : !state.partyId
            // ? "Party Id"
            !state.quantity
            ? "quantity"
            : !state.amount
            ? "Amount"
            : !state.retrn
            ? "Return"
            : "" // : !state.saleRate
          // ? "Sale Rate"
          // !state.purchaseRate
          // ? "Purchase Rate"
          // : ""
        }`
      );
    } else {
      const payload = {
        id: state.id,
        // generalLedgerCode: state.glCode,
        // partyId: Number(state.partyId),
        itemCode: state.itemCode,
        // remrks: state.remrks,
        lorryNo: state.lorryNo,
        quantity: Number(state.quantity),
        purchaseRate: Number(state.purchaseRate),
        // saleRate: Number(state.saleRate),
        amount: Number(state.amount),
        retrn: Number(state.retrn),
        // tankNumber: state.tank,
      };

      console.log(payload, "payyyyyyyyy");
      const response = await updateTankLorry(payload, access_token);
      if (response.success) {
        await editHandler();
        message.success(response.message);
        clearState();
        setFieldsShow(false);
      } else {
        message.error(response.message);
      }
    }
  };

  // ---------------- DELETE PURCHASE

  // -------- single

  const [modal, contextHolder] = Modal.useModal();
  const deleteSinglePurchase = async (id) => {
    console.log("deleteSingle");
    const results = await deleteSingleTankLorry(id, access_token);
    if (results.success) {
      if (itemsQueue.length !== 1) {
        await editHandler();
      } else {
        setItemsQueue([]);
      }
      message.success("Record Deleted Successfully !");
      // clearStates()
    } else {
      message.error(results.message);
    }
  };

  const confirmDelete = (id) => {
    modal.confirm({
      title: `Confirm`,
      content: "Are you sure you want to delete this Record?",
      okText: "Delete",
      cancelText: "Cancel",
      onOk: () => deleteSinglePurchase(id),
    });
  };

  // -------- whole data

  const [deletePopup, setDeletepopup] = useState(false);
  const deletePurchase = () => {
    setDeletepopup(true);
  };

  const deletePurchaseHandler = async () => {
    const results = await deleteTankLorry(voucher, access_token);
    if (results.success) {
      clearStates();
      message.success("Record Deleted Successfully !");
      clearStates();
      setDeletepopup(false);
    } else {
      message.error(results.message);
    }
  };
  const confirmDeleteAll = () => {
    modal.confirm({
      title: `Confirm`,
      content: "Are you sure you want to delete this Voucher?",
      okText: "Delete",
      cancelText: "Cancel",
      onOk: () => deletePurchaseHandler(),
    });
  };
  const menu = (index) => {
    return (
      <Menu>
        <Menu.Item key="0">
          <button
            onClick={() => {
              setFieldsShow(true);
              setEditedItem(index);
              setState(itemsQueue[index]);
              console.log(itemsQueue, "edit");
            }}
          >
            <AiFillEdit className="mr-2 mt-1" />

            <span>Edit</span>
          </button>
        </Menu.Item>
        {type === "SAVE" ? (
          <Menu.Item key="1">
            <button
              onClick={() => {
                deleteItem(index);
              }}
            >
              {" "}
              Delete
            </button>
          </Menu.Item>
        ) : (
          <Menu.Item key="1">
            <button
              onClick={() => {
                confirmDelete(itemsQueue[index].id);
              }}
            >
              {" "}
              Delete
            </button>
          </Menu.Item>
        )}
      </Menu>
    );
  };
  return (
    <div className="flex  bg-black recive-main">
      <SideBar />
      <div className="h-full  flex flex-col content-center  w-full">
        <div className="meterTableMain ml-10 mt-6o mr-10">
          {contextHolder}
          <div className="bg-blue-500 headingBox flex justify-between">
            <h3 className=" text-white tableHeading pl-10">Tank Lorry</h3>
          </div>
          <div className="bg-blue-500">
            <div
              className="flex content-center  ml-10 pb-3"
              style={{
                display: "flow-root",
              }}
            >
              {/* <input
                readOnly
                value={voucher}
                className="custom-select inpTxt p-2 h-9  mb-3 w-40"
              /> */}
              <input
                type="date"
                value={dateEntered}
                className="text-black inpTxt p-2 h-9 ml-3 mb-3 w-40"
                onChange={(e) => setDateEntered(e.target.value)}
              />
              <input
                type="number"
                name=""
                value={shift}
                placeholder="Shift"
                className=" text-black inpTxt p-1 h-9 ml-3 w-14"
                onChange={(e) => setShift(e.target.value)}
              />
              {fieldsShow && (
                <>
                  {/* <Select
                    showSearch
                    className=" bg-white   text-white ml-3 mt-5 inpTxt  p-1 h-9  w-52"
                    placeholder="Supplier Name"
                    optionFilterProp="children"
                    value={state.partyName || "Supplier Name"}
                    onChange={(e) => {
                      const { PartyName, chartOfAccount } = state.parties.find(
                        (el) => el.partyId === e
                      );
                      setState({
                        ...state,
                        partyId: e,
                        partyName: PartyName,
                        glCode: chartOfAccount.generalLedgerCode,
                        glDescription: chartOfAccount.description,
                      });
                    }}
                  >
                    {state.parties.map((el) => (
                      <Option value={el.partyId}>{el.PartyName}</Option>
                    ))}
                  </Select> */}
                  {/* <Select
                    showSearch
                    disabled={Boolean(state.partyId)}
                    className="ant-select bg-white text-white ml-3 mt-5 inpTxt  p-1 h-9  w-52"
                    placeholder="GL Description"
                    optionFilterProp="children"
                    value={state.glDescription || "GL Description "}
                    onChange={(e) => {
                      const lCode = state.ledgerCodes.find(
                        (el) => el.generalLedgerCode === e
                      );
                      setState({
                        ...state,
                        glCode: e,
                        glDescription: lCode.description,
                      });
                    }}
                  >
                    {state.ledgerCodes.map((el) => (
                      <Option value={el.generalLedgerCode}>
                        {el.description}
                      </Option>
                    ))}
                  </Select> */}
                  <Select
                    showSearch
                    placeholder="Select Product Name"
                    optionFilterProp="children"
                    className="ant-select bg-white text-white ml-3 mt-5 inpTxt  p-1 h-9  w-52"
                    //   className=" ant-select bg-black text-white  mt-5 inpTxt p-1 h-9 ml-3 w-52"
                    value={state.itemName || "Prodct Name"}
                    onChange={(e) => {
                      const { itemName } = state.items.find(
                        (el) => el.itemCode === e
                      );
                      setState({ ...state, itemCode: e, itemName: itemName });
                    }}
                  >
                    {state.items.map((el) => (
                      <Option value={el.itemCode}>{el.itemName}</Option>
                    ))}
                  </Select>
                </>
              )}
            </div>
          </div>
          {fieldsShow && (
            <div className="">
              <div className="flex content-center flex-wrap  ml-10">
              <input
                  type="number"
                  name="voucher"
                  value={state.voucher}
                  onChange={onChangeText}
                  placeholder="Voucher"
                  className="bg-black text-white  mt-5 inpTxt pt-3 p-1 h-9 ml-3 w-28"
                />
                {/* <div className="">
                  <Select
                    showSearch
                    placeholder="A/C No."
                    className="ant-select ant-select bg-black text-white  mt-5 inpTxt  p-1 h-9  w-60 "
                    optionFilterProp="children"
                    value={state.partyId || "A/C No."}
                    onChange={(e) => {
                      console.log("e", e);

                      const _party = state.parties.find(
                        (el) => el.partyId === e
                      );
                      if (_party) {
                        setState({
                          ...state,
                          partyId: e,
                          partyName: _party.PartyName,
                          glCode: _party.chartOfAccount.generalLedgerCode,
                          glDescription: _party.chartOfAccount.description,
                        });
                      } else {
                        setState({
                          ...state,
                          partyId: e,
                          partyName: "",
                          glCode: "",
                          glDescription: "",
                        });
                      }
                    }}
                  >
                    <Option value={0}>None</Option>
                    {state.parties.map((el) => (
                      <Option
                        value={el.partyId}
                      >{`${el.partyId} - ${el.PartyName}`}</Option>
                    ))}
                  </Select>
                </div> */}

                {/* <div className="">
                  <Select
                    showSearch
                    disabled={Boolean(state.partyId)}
                    className="ant-select bg-black text-white ml-3 mt-5 inpTxt  p-1 h-9  w-36"
                    placeholder="Credit GL Code"
                    optionFilterProp="children"
                    value={state.glCode || "Credit GL Code"}
                    onChange={(e) => {
                      const lCode = state.ledgerCodes.find(
                        (el) => el.generalLedgerCode === e
                      );
                      setState({
                        ...state,
                        glCode: e,
                        glDescription: lCode.description,
                      });
                    }}
                  >
                    {state.ledgerCodes.map((el) => (
                      <Option value={el.generalLedgerCode}>
                        {` ${el.generalLedgerCode}`}
                      </Option>
                    ))}
                  </Select>
                </div> */}
                <Select
                  showSearch
                  placeholder="Select item"
                  className=" ant-select bg-black text-white  mt-5 inpTxt p-1 h-9 ml-3 w-32"
                  optionFilterProp="children"
                  value={state.itemCode || "Item"}
                  onChange={(e) => {
                    const { itemName } = state.items.find(
                      (el) => el.itemCode === e
                    );
                    setState({ ...state, itemCode: e, itemName: itemName });
                  }}
                >
                  {state.items.map((el) => (
                    <Option value={el.itemCode}>
                      {el.itemCode} - {el.itemName}
                    </Option>
                  ))}
                </Select>
                <input
                  type="text"
                  name="lorryNo"
                  value={state.lorryNo}
                  onChange={onChangeText}
                  placeholder="Lorry Number"
                  className="ant-select bg-black text-white mt-5  inpTxt pt-3 p-1 h-9 ml-3"
                />

                <input
                  type="number"
                  name="quantity"
                  id=""
                  value={state.quantity}
                  onChange={(e) => {
                    if (state.purchaseRate) {
                      setState({
                        ...state,
                        amount: e.target.value * state.purchaseRate,
                        quantity: e.target.value,
                      });
                    } else {
                      setState({ ...state, quantity: e.target.value });
                    }
                  }}
                  placeholder="Quantity"
                  className="ant-select bg-black text-white mt-5  inpTxt pt-3 p-1 h-9 ml-3 w-24"
                />
                <input
                  type="text"
                  name="purchaseRate"
                  value={state.purchaseRate}
                  onChange={(e) => {
                    if (state.quantity) {
                      setState({
                        ...state,
                        amount: e.target.value * state.quantity,
                        purchaseRate: e.target.value,
                      });
                    } else {
                      setState({ ...state, purchaseRate: e.target.value });
                    }
                  }}
                  placeholder="P/Rate"
                  className="ant-select bg-black text-white mt-5  inpTxt pt-3 p-1 h-9 ml-3 w-24"
                />

                <input
                  type="number"
                  name="amount"
                  value={state.amount}
                  onChange={(e) => {
                    if (state.quantity) {
                      setState({
                        ...state,
                        purchaseRate: e.target.value / state.quantity,
                        amount: e.target.value,
                      });
                    } else {
                      setState({ ...state, amount: e.target.value });
                    }
                  }}
                  placeholder="Amount"
                  className="bg-black text-white  mt-5 inpTxt pt-3 p-1 h-9 ml-3 w-28"
                />
                <input
                  type="number"
                  name="retrn"
                  value={state.retrn}
                  onChange={onChangeText}
                  placeholder="Return"
                  className="bg-black text-white  mt-5 inpTxt pt-3 p-1 h-9 ml-3 w-28"
                />

                {Boolean(editedItem != null) ? (
                  <button
                    onClick={editItem}
                    className="bg-blue-500 hover:bg-blue-700 text-white  mt-5 ml-3 py-1 px-4 rounded"
                  >
                    {/* <AiFillEdit className="mr-2 mt-1" /> */}

                    <span>Edit</span>
                  </button>
                ) : (
                  <button
                    onClick={addItem}
                    className="bg-blue-500 hover:bg-blue-700 text-white mt-5  p-1 h-9 ml-3 w-20 rounded"
                  >
                    <span> + Add</span>
                  </button>
                )}
              </div>
            </div>
          )}

          <div className="div">
            <div className="flex">
              <div
                className="overflow-x-auto   shadow-md sm:rounded-lg tableDiv p-5 pl-10  w-full"
                style={{ maxHeight: "400px" }}
              >
                <table className=" w-full text-sm text-left text-gray-500 dark:text-gray-400">
                  <thead className="bg-blue-500 text-white uppercase dark:bg-gray-700 tableHeading  dark:text-gray-400">
                    <tr>
                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium "
                        scope="col"
                      >
                        SNo.
                      </th>
                      {/* <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        GL CODE
                      </th>
                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        GL DESCRIPTION
                      </th>
                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        Party
                      </th>
                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        Party Name
                      </th> */}
                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        Item
                      </th>
                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        Item Name
                      </th>

                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        Lorry No
                      </th>
                      {/* <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        Description
                      </th> */}
                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        QTY
                      </th>
                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        P/Rate
                      </th>
                      {/* <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        S/Rate
                      </th> */}
                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        Amount
                      </th>
                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        Return
                      </th>

                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium"
                        scope="col"
                      >
                        ACTION
                      </th>
                    </tr>
                  </thead>
                  <tbody className="tableBody">
                    {itemsQueue.map((ele, i) => {
                      return (
                        <tr key={i} className="tbodyData text-white">
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            {i + 1}
                          </td>
                          {/* <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.glCode}</p>
                          </td>{" "}
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.glDescription}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.partyId}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.partyName}</p>
                          </td> */}
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.itemCode}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.itemName}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.lorryNo}</p>
                          </td>
                          {/* <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.remrks}</p>
                          </td> */}
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.quantity}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.purchaseRate}</p>
                          </td>
                          {/* <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.saleRate}</p>
                          </td> */}
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.amount}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.retrn}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <Dropdown overlay={menu(i)} placement="bottomLeft">
                              <Button>Action</Button>
                            </Dropdown>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <div className="flex justify-end">
                  <input
                    type="text"
                    readOnly
                    placeholder=""
                    name=""
                    id=""
                    value={total}
                    className="mt-5 pl-10 pt-1 pb-1 w-32 bg-black text-white outline-none"
                  />
                </div>
                <div className="flex justify-between">
                  <div className="flex">
                    {type === "ADD" && (
                      <button
                        onClick={addVoucher}
                        className="bg-blue-500 hover:bg-blue-700 h-9 flex text-white mt-3 py-1 px-4 rounded"
                      >
                        <AiFillFileAdd className="mr-2 mt-1" />

                        <span>Add</span>
                      </button>
                    )}

                    {type === "SAVE" && (
                      <button
                        onClick={save}
                        className="bg-blue-500 hover:bg-blue-700 h-9 flex text-white mt-3 py-1 px-4 rounded"
                      >
                        <AiFillSave className="mt-1 mr-2 " />
                        <span>Save</span>
                      </button>
                    )}

                    {type === "ADD" && (
                      <button
                        onClick={edit}
                        className="bg-blue-500 hover:bg-blue-700 h-9 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                      >
                        <AiFillEdit className="mr-2 mt-1" />

                        <span>Edit</span>
                      </button>
                    )}

                    <button
                      onClick={() => deletePurchase()}
                      className="bg-blue-500 hover:bg-blue-700 h-9 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                      disabled={type !== "ADD"}
                    >
                      <AiFillDelete className="mr-2 mt-1" />

                      <span>Delete</span>
                    </button>
                    <button
                      onClick={() => {
                        clearStates();
                      }}
                      className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 h-9 ml-3 py-1 px-4 rounded"
                    >
                      <BiExit className="mr-2 mt-1" />
                      {type === "EDIT" ? "Done" : "Exit"}
                    </button>
                  </div>
                  <div className="flex content-end mt-3 bg-white justify-end"></div>

                  <div>
                    <button className="bg-blue-500 hover:bg-blue-700 text-white mt-3 py-1 px-4 rounded">
                      <img src={`./img/first.png`} alt="" />
                    </button>
                    <button className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded">
                      <img src={`./img/previous.png`} alt="" />
                    </button>
                    <button className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded">
                      <img src={`./img/next.png`} alt="" />
                    </button>
                    <button className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded">
                      <img src={`./img/latest.png`} alt="" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Popup popup={editPopup} handlePopup={setEditpopup} onOk={editHandler}>
        <div>
          <h2>Please type voucher number</h2>
          <input
            style={{
              border: "1px solid",
            }}
            autoFocus
            type="number"
            value={voucher}
            onChange={(e) => setVoucher(e.target.value)}
          />
        </div>
      </Popup>

      <Popup
        popup={deletePopup}
        handlePopup={setDeletepopup}
        onOk={confirmDeleteAll}
      >
        <div>
          <h2>Please type voucher number for delete record</h2>
          <input
            style={{
              border: "1px solid",
            }}
            autoFocus
            type="number"
            value={voucher}
            onChange={(e) => setVoucher(e.target.value)}
          />
        </div>
      </Popup>
    </div>
  );
};

export default TankLorry;
